import withInjection from '@piconetworks/with-injection'

import WizardRedux from 'common/pkgs/WizardRedux'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'

import { getNavigateBackButton } from 'common/pkgs/WizardNavigation'

import GiftForm from './GiftForm'

const mapStateToProps = (state, props) => {
    const { router } = props
    const wizardTypes = Wizard.selectors.wizardTypes(state)
    const popupId = Wizard.selectors.thisWizardPopupId({ state, router })

    /*
    * if we are in the checkout_wizard,
    * and we want to give a gift
    * going back shouldn't take us back to the giftwizard
    * we can check for this by identifying the presence of both gift and checkout wizards
    */
    const checkoutWizardExists = Wizard.selectors.getWizard({ state, type: 'CheckoutWizard' })

    const backButton = getNavigateBackButton({
        wizardTypes,
        popupId,
        router,
        ...(checkoutWizardExists && { wizardName: 'CheckoutWizard' }),
    })

    const productOptionId = Wizard.selectors.thisWizardProductOptionId({ state, router })

    return {
        ...props,
        WizardRedux,
        thisWizard: Wizard.selectors.thisWizard({ state, router }),
        headerText: 'Go to Inbox Trips',
        headerDescription: 'Already a subscriber?',
        loader: Loader.selectors.loader(state),
        getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
        productOptionId,
        onBackButtonClick: backButton.onClick,
    }
}

const InjectedGiftForm = withInjection(GiftForm, {
    mapStateToProps,
})

export default InjectedGiftForm
